import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  backdrop: {
    zIndex: 2000,
    color: '#fff',
  },
}));

const Loading: React.FC<React.PropsWithChildren<{ open: boolean }>> = ({ open }) => {
  const { classes } = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={open}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Loading;
